import "../styles/remote-store-details.css";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { Skeleton } from "primereact/skeleton";
import { PrimeIcons } from "primereact/api";
import OffPlusController from "../services/offplus-controller";
import { Carousel } from "primereact/carousel";

export default function RemoteStoreDetails(props) {
	const { t } = useTranslation();
	const localizer = t;
	const offPlusController = new OffPlusController();
	const [isLoading, setIsLoading] = useState(false);
	const [store, setStore] = useState({});

	const getData = async function () {
		try {
			setIsLoading(true);
			let code = "";
			if (window.location.href.indexOf("?") > 0) {
				let urlParams = new URLSearchParams(window.location.href.split("?")[1]);
				code = urlParams.get("code");
			}
			const storeResult = await offPlusController.getRemoteStore(code);
			if (storeResult.isSuccess === false) throw storeResult.message;
			setStore(storeResult.value);
		} catch (error) {
			alert(error.toString());
		}
		setIsLoading(false);
	};

	const imageTemplate = (image) => {
		return (
			<div className="banner">
				<img src={image.imageUrl} alt={"تصویر فروشگاه"} />
			</div>
		);
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<div>
			{isLoading === true && (
				<>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
					</div>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
					</div>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
					</div>
				</>
			)}

			<div className="remote-store-details">
				<div>
					<aside>
						<Carousel
							value={store.images}
							numVisible={1}
							numScroll={1}
							itemTemplate={imageTemplate}
							autoplayInterval={3000}
							circular
						/>

						<ol>
							<li>
								<a href={store.webSite} target="_blank">
									<i className={PrimeIcons.GLOBE}></i>
								</a>
							</li>
							<li>
								<a href={store.telegram} target="_blank">
									<i className={PrimeIcons.TELEGRAM}></i>
								</a>
							</li>
							<li>
								<a href={store.instagram} target="_blank">
									<i className={PrimeIcons.INSTAGRAM}></i>
								</a>
							</li>
						</ol>
					</aside>
					<section>
						<h2>{store.name} </h2>

						{store.videoUrl && (
							<video controls>
								<source src={store.videoUrl} type="video/mp4" />
							</video>
						)}
						<h3>توضیحات تکمیلی</h3>
						<p dangerouslySetInnerHTML={{ __html: store.notes }}></p>
						<h3>آدرس</h3>
						<p>{store.address}</p>

						<div className="buttons">
							<a href={`tel:${store.tel}`}>تماس : {store.tel}</a>
							<a
								className="request"
								href={`https://offplus.ir/%DA%A9%D8%A7%D9%84%D8%A7%D9%87%D8%A7-%D9%88-%D8%AE%D8%AF%D9%85%D8%A7%D8%AA?store=${store.code}`}
							>
								خرید محصولات / خدمات...
							</a>
						</div>
					</section>
				</div>
				<ul className="remote-products">
					{store.products?.map((item) => (
						<li>
							<a
								href={`https://offplus.ir/product/${
									item.code
								}_${item.name.replace(/ /g, "-")}`}
								target="_blank"
							>
								<img src={item.imageUrl} />
								<h2>{item.name}</h2>
							</a>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
}
